import EventEmitter from "eventemitter3";
import Store from "./Store";

class OfferArchive {
    EEE: EventEmitter;
    archiveContentClass: string;
    activeClass: string;

    constructor() {
        this.EEE = new EventEmitter();
        this.archiveContentClass = ".offers__archive-content";
        this.activeClass = "offers__archive-content--is-active";

        const archivesContent = document.querySelector(
            this.archiveContentClass,
        );

        if (archivesContent) {
            this.toggleArchive();
            this.EEE.on("STORE_CHANGED", () => {
                this.toggleArchive();
            });
        }
    }

    toggleArchive() {
        this.resetVisibility();

        const currentStore = Store.getCurrentStore();
        if (
            currentStore &&
            currentStore.offers_weekly &&
            currentStore.offers_weekly.archive_content
        ) {
            const offerID = currentStore.offers_weekly.archive_content;
            const archivesContent = document.querySelectorAll(
                this.archiveContentClass + '[data-offer="' + offerID + '"]',
            );
            if (archivesContent.length > 0) {
                [...Array.from(archivesContent)].forEach((archiveContent) => {
                    archiveContent.classList.add(this.activeClass);
                });
            }
        }
    }

    /**
     * Reset Visibility
     */
    resetVisibility() {
        const archivesContent = document.querySelectorAll(
            this.archiveContentClass,
        );
        if (archivesContent.length > 0) {
            [...Array.from(archivesContent)].forEach((archiveContent) => {
                archiveContent.classList.remove(this.activeClass);
            });
        }
    }
}

export default OfferArchive;
